export default {"src":"/_next/static/media/mozo-award.b2d744ba.svg","height":85,"width":167};